import styled from 'styled-components';
/**
    GradientBox is placed over TrailerOrStripeImageComponent using position absolute.
    We do this because TrailerOrStripeImageComponent has opacity 0.5
    and we can't put GradientBox inside TrailerOrStripeImageComponent because will inherit that opacity
 */
export const GradientDefaultBox = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to bottom, transparent 46%, ${props => props.theme.colors.background} 100%); 
`;